/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-10 11:32:28
 */
export default{
    base:{
        username:'Username',
        password:'Password',
        email:'Email',
        newPassword:'New Password',
        confirmPassword:'Confirm Password',
        signIn:'SIGN IN',
        signUp:'SIGN UP',
        confirm:'CONFIRM',
        confirm2:'Confirm',
        newPassword:'New Password',
        confirmPassword:'Confirm Password',
        login:'Login',
        feishuLogin:'Login Using Feishu',
        larkLogin:'Login Using Lark',
        tip:'Tip',
        operateSuccess:'Operation successful!',
        cancel:'Cancel',
        ok:'OK',
        operate:'Operate',
        more:'More',
        save:'Save',
        sync:'Sync',
        loading:'Loading...',
        exporting:'Exporting...',
        exportSuccess:'Export successful',
        export:'Export',
        yes:'YES',
        no:'NO',
        YES:'YES',
        NO:'NO',
        line:'Line',
        sorry:'Sorry',
        noPage:'The current page does not exist...',
        shareLink:'Copy Link',
        previewFile:'Preview',
        qrcode:'QR Code',
        copyFailed:'Copy Failed',
        formatError:'format error !',
        download:'Download',
        delete:'Delete',
        base:'BASE',
        cc:'CC',
        operation:'Operateion',
        operationRecord:'Operation Record',
        email:'Email',
        name:'Name',
        moreInfo:'More Information',
        companyInfo:'Company Information',
        year:'Year',
        month:'Month',
        week:'Week',
        weeks:'Weeks',
        start_week:'Begin Week',
        end_week:'End Week',
        beginDate:'Start Date',
        endDate:'End Date',
        error:'Error',
        update:'Update',
        en:'EN',
        de:'DE',
        
        clearCache:'Clear Cache',
        logout:'Logout',
        search:'Search',
        add:'Add',
        edit:'Edit',
        invalid:'Invalid',
        detail:'Detail',
        reset:'Reset',
        input:'Please enter',
        selecteData:'Please select data',
        select:'Please select',
        selecteDate:'Please select date',
        pleaseSelectType:'Please select type',

        setSuccess:'Set successfully',
        saveSuccess:'Successfully Saved',
        addSuccess:'Successfully Added',
        createSuccess:'Created successfully',
        updateSuccess:'Successfully Update',
        invalidSucess: 'Invalid successfully',
        addFail:'Adding Failed：',
        editSuccess:'Successfully Edited',
        editFail:'Editing Failed：',
        delSuccess:'Successfully Deleted',
        delFail:'Delete Dailed：',
        syncSuccess:'Synchronization Successful',
        syncFail:'Synchronization Failed：',
        downloadSuccess:'Download Successful',
        confirmSuccess:'Confirm Successful',
        notSync:'Not synchronized',
        delConfirmTip:'Are you sure to delete?',
        noEmpty:'cannot be empty!',
        noZero:'cannot be 0 !',
        sendSuccess:'Successfully Send',
        sending:'Sending...',
        send:'Send',
        assignSuccess:'Successfully Assign',
        selectData:'Please select data',
        cancelSuccess:'Successfully Cancel',
        success:'Success',
        fail:'Fail',
        amountIncludeTax:'Amount including tax',
        discountIncludeTax:'Discount including tax',
        uploadImg:'Upload Images',
        notLess0:'cannot be less than 0',

        filter:'Filter',
        large:'Large',
        medium:'Medium',
        small:'Small',

        open:'open',
        close:'close',

        enterEmail:'Please enter email',
        enterUser:'Please enter user',
        enterSomething:'Please enter something',
        emailReceiveTip:"Email for sending dealer's collection list",
        operation:'Operation',
        date:'Invoice Date',
        deleteConfirmTip:'Are you sure delete?',
        cancelConfirmTip:'Are you sure cancel?',
        isConfirmTip:'Are you sure confirm?',
        saveTip:'Are you sure save?',
        setting:'Setting',

        detail:'Details',
        date:'Date',
        confirm2:'Confirm',
        cancelEdit:'Cancel Edit',

        uploadFileTip:'Please upload the file.',
        total:'Total',
    },
    login:{
        title:"Hello! let's get started",
        subTitle:'Sign in to continue.',
        bottomTitle:"Don't have an account?",
        create:'Create',
        remmenber:'Keep me signed in',
        fogget:'Forgot password?',
        usernameEmpty:'User name is empty!',
        emailEmpty:'Email is empty!',
        passwordEmpty:'Password is empty!',
        feishuLoginError:'Login exception! error message',
        backFeishuLogin:'Return to feishu login page',

        completeVeriftyTitle:'Please complete security verification',
        swipeRight:'Swipe right to complete verification',
        verificationFailed:"Verification failed",
        verificationSuccessful:'Verification successful',
        clickMoreOne:'Please click on them one by one',
        errorPageTip:'Please check if the URL you entered is correct, or click the button below to return to the order management page.',
        jumpToOrder:'jump to the order management page',
    },
    signUp:{
        title:'New here?',
        subTitle:'Signing up is easy. It only takes a few steps',
        bottomTitle:'Already have an account?',
        tip:'Registration successful! Go to login',
        error_email:'Email format error!',
        emailEmpty:'Email is empty!',
        passwordVaildMsg:'Password length 6-10 digits, consisting of numbers and letters',
        password:'Password',
        emailVaildMsg:'This email has been registered!'
    },
    confirmPwd:{
        title:'Forgot password?',
        subTitle:'Resetting the password is easy. Just a few steps',
        bottomTitle:'Already have an account?',
        editPwd:'Password modification successful',
        vaildPwd:'Password inconsistency!',
        emailMsgEmpty:'Email is empty!',
        newPasswordEmpty:'New password is empty!',
        confirmPasswordEmpty:'Confirm password is empty!',
    },
    menu:{
        home:'Home', 
        orderList:'Orders', 
        prepaidOrderList:'Proforma Orders',
        returnOrder:'Special Return Orders',
        invoiceList:'Invoices',
        productList:'Products', 
        productQuery:'E-Bike Inventory',
        availabilityEdit:'Availability Edit',
        availabilityReport:'EBike Availability',
        eBikeAvailability:'Inventory',
        customerList:'Customers',
        orderApprovalList:'OOS Order Approval',
        B2BShopOrderList:'B2B Shop Orders',
        dealerOpenOrder:'Backorders',
        preOrderList:'OOS Orders',
        dealerList:'Dealers',
        saleGoal:'Sale Goal',
        financial:'Financial MGT.',
        financialReceipts:'Financial',
        log:'System Logs',
        errorLog:'Error Log', 
        orderRiskVerificationLog:'Order Risk Log',
        config:'Base Data Setup',
        soSyncConf:'SO Sync Filter',
        orderSource:'Channels',
        // emailReceive:'Dealer Overdue Email Config',
        emailReceive:'Emails',
        countryCodeConfig:'Country Codes',
        setting:'System Setting', 
        role:'Role Authority MGT.', 
        user:'User Role MGT.',
        orderSubList:'Orders',
        returnExchangeList:'Return And Exchange List',
        addEmail:'Email Registration MGT.',
        dashboard:'Data & Report',
        dataStatistics:'Data Statistics',
        stockOutList:'Outbounds',
        menuManage:'Menu MGT.',
        newMenu:'New Menu',
        dealerGoal:'Dealer Goal',
        saleFrameGoal:'Sale Goal',
        cash:'Cash Flow',
        accounts:'Receivables & Payables',
        priceList:'Channels Prices',
        productPlanList:'Availability Planning',
        taxConfig:'Tax Rates',
        saleDealerConfig:'Sale-Dealer Config',
        areaSaleManagerConfig:'Area Sale Managers',
        dealerLevelConfig:'Dealer Level Config',
        deliveryDateRangeConfig:'Delivery Blocks',
        bomQuery:'E-Bike Parts',
        kpiDailyReport:'KPI Daily Report',
        warningList:'Outbound Alert',
        signatureList:'Signed For',
        inventoryLock:'Inventory Lock',
        preSaleOrder:'Pre Orders',
        customers:'Customers',
        outbounds:'Outbounds',
        history:'Historic Items',
    },
    order:{
        deliver:'Shipping Apply',
        invoice:'Shipment Form',
        curStock:'Current Inventory',
        deliverRecord:'Shipping Record',
        viewLogistics:'Logistics Info',
        refundRecord:'Refund Record',
        downloadInvoice:'Download Invoice',
        sendInvoice:'Send Invoice',
        addProduct:'Add Lines',
        syncToERP:'Sync To ERP',
        delete:'Delete',
        cancelSO:'Cancel SO',
        cancelSORecord:'Cancel SO Record',
        editOrder:'Edit Order',
        returnFactory:'Return Factory',

        deliverRecord2:'Shipping',
        refundRecord2:'Refund',
        cancelSO2:'Cancel',
        cancelSORecord2:'Cancel SO',
        downloadInvoice2:'Download',
        sendInvoice2:'Send',
        viewLogistics2:'Logistics',
        base:'BASE',
        invoice:'INVOICE',
        record:'RECORD',
        changeOrderStatus:'Change Order Status',
        cancelOrder:'Cancel',
        refundOrder:'Refund',
        deleteInvoice:'Delete',
        createPrepaymentOrder:'Create Proforma Order',
        linePrePaidQuantity:'PrePaid',
        invoice2:'Invoice',

        finalPayment:'Final Payment Note',
        partialPay:'Partial Paid',
        pay:'Paid',
        refund:'Full Refunded',
        returnsAndRefund:'Return And Refunded',
        partialRefund:'Partial Refunded',
        partialReturnsAndRefund:'Partial Return And Refunded',
        cancel:'Canceled',
        unship:'Unship',
        plan:'Plan',
        partialShip:'Partial Shipped',
        shiped:'Shipped',
        signedFor:'Signed For',
        close:'Close',
        obligation:'Pending Payment',
        fail:'Fail',
        unknown:'Unknown',
        partialReturn:'Partial Return',
        partialExchange:'Partial Exchange',
        return:'Return',
        exchange:'Exchange',
        user:'User',
        dealer:'Dealer',
        c2c:'C&C',
        virtual: 'Virtual',
        initial:'Initial',
        outbound:'Outbound',
        unOutbound:'UnOutbound',
        uploading:'Uploading',

        other:'Other',
        shopify:'Shopify',
        jobrad:'Jobrad',
        bikeExchange:'Bike Exchange',
        amazonSeller:'Amazon Seller',
        decathlon:'Decathlon',
        factoryDirectSales:'Factory Direct Sales',
        amazonVendor:'Amazon Vendor',
        alltricks:'All Tricks',
        dealer:'Dealer',
        notSalesOrder:'Not Sales Order',
        notForSale:'Samples',
        

        deliverTip:'Please select the products that need to be shipped under this order first !',
        selectWms:'Please select a warehouse first, check inventory, and then ship !',
        courierTip:'Logistics company, logistics tracking number, and warehouse cannot be empty !',
        courierTip2:'Logistics company, logistics link, and warehouse cannot be empty !',
        courierTip3:'Logistics company and warehouse cannot be empty !',
        quantityTip:'Ship QTY cannot be greater than the order QTY !',
        quantityTip2:'Ship QTY cannot be empty !',
        quantityTip3:'The sum of the ship QTY and the shipping QTY cannot be greater than the ordered QTY !',
        quantityTip4:'Ship QTY cannot be greater than the locked QTY !',
        quantityTip5:'Insufficient available quantity !',
        quantityTip6:'The shipping date cannot be empty !',
        quantityTip7:'The warehouse cannot be empty !',
        quantityTip8:'Ship QTY cannot be greater than the quantity available for shipment !',
        quantityTip9:'The e-bike warehouses are different and cannot apply for shipment !',

        orderNumber:'Order Number',
        orderName:'Order No.',
        // orderSource:'Source',
        dealerOrderName:'Dealer Order No.',
        orderSource:'Channels',
        orderStatus:'Order Status',
        customerType:'Customer Type',
        country:'Country',
        erpNo:'ERP SO No.',

        courierStatus:'Logistics Status',
        courierType:'Logistics Type',
        courierNo:'Logistics No.',
        orderDate:'Order Date',
        deliverQty:'Deliver QTY',
        curQuantity:'Ship QTY',

        deliverDetailTitle:'Shipment Details',

        orderAmount:'Order Amount',
        orderDiscount:'Discount',
        orderTax:'Order Tax',
        InvoiceAmount:'Invoice Amount',
        payAmount:'Pay Amount',
        payAmount3:'Payment',
        refundAmount:'Refund Amount',
        realPayAmount:'Real Pay Amount',
        payCurrency:'Pay Currency',
        deliverStatus:'Shipment Status',
        customerType:'Customer Type',
        orderTimestamp:'Order Date',
        refundTimestamp:'Refund Date',
        customerEmail:'Customer Email',
        customerName:'Customer Name',
        customerInvoiceName:'Invoice Address',
        country:'Country',
        outboundStatus:'Outbound Status',
        unitCode:'Unit',
        erpLineNo:'ERP Line No.',
        deliveryNumber:'Shipment Notification No.',

        orderLineNo:'Order Line No.',
        inventoryCode:'ERP Product Code',
        warehouse:'Warehouse',
        quantity:'Order QTY',
        needShipquantity:'Need Ship QTY',
        shipQuantity:'Shipping QTY',
        shippedQuantity:'Shipped QTY',
        backQuantity:'Back QTY',
        deliveryDate:'Delivery Date',
        sku:'SKU',
        productName:'Product Name',
        productName2:'Name',
        wms:'Warehouse',
        inventory:'Inventory',
        amount:'Amount (Inc. Tax)',
        discount:'Discount',
        price:'Unit Price(Including Tax)',
        unitPrice:'Unit Price',
        depositAmount:'Deposit Amount(Including Tax)',
        torque:'Torque',
        operate:'Operate',
        frameShape:'Shape',

        logisticsDetail:'Logistics Detail',

        courierLink:'Logistics URL',
        referenceInventory:'Total QTY',
        happenedTime:'Logistics Update Date',

        noCourierInfo:'There is currently no logistics information available',

        create:'Create Order',
        preAmount:'Deposit Amount',
        handleTimestamp:'Shipping Date',
        taxRate:'Tax Rate',
        createSuccess:'Successfully created order!',
        customerErpCode:'ERP Code',
        baseInfo:'Base Information',
        amountInfo:'Amount Information',
        customerInfo:'Customer Information',
        edit:'Edit',
        cancel:'Cancel',
        edit2:'edit',
        cancel2:'cancel',
        delete2:'delete',
        cancelLineSO:'cancel SO',
        changeConfirmTip:'Are you sure to change the order status to 【paid】?',
        changeConfirmTip2:'Are you sure to change the order status to 【cancel】?',
        changeConfirmTip3:'Are you sure to change the order status to 【refund】?',
        changeConfirmTip4:'Are you sure to change the order status to 【pending payment】?',
        changeConfirmTip5:'Are you sure to change the order status to 【partial paid】?',
        cancelERPSOTip:'Please cancel the ERP SO first',
        syncConfirmTip:'Are you sure to synchronization?',
        changeSKUTip:'Are you sure to modify SKU?',
        viewVersion:'View Version',
        viewVersion2:'version',
        version:'Order Line Version',
        operator:'Operator',
        sendInvoiceMsg:'Are you sure to send the invoice to the customer? The customer can download the invoice for preview',
        sendInvoiceMsg2:'The email has been sent ',
        sendInvoiceMsg3:' times.',
        sendInvoiceMsg4:'Please confirm if you need to send it again',
        sendConfirmationMsg:'Are you sure to send the order confirmation to the customer? The customer can download the order confirmation for preview',

        cancelQty:'Cancel',
        cancelConfirmTip:'Are you sure to cancel?',
        cancelStatus:'Cancel Status',
        partialCanceled:'Partial Canceled',
        canceled:'Canceled',
        notCancel:'Not Cancelled',
        type:'Type',
        syncStatus:'Synchronous Status',
        success:'Success',
        fail:'Fail',
        notSync:'Not Sync',
        schedulingQuantity:'Reserved QTY',
        availableQty:'Real Availability',
        versionTime:'Version Time',
        cancelQuantity:'Cancel QTY',

        backNumber:'Return No.',
        backStatus:'Back Status',
        returning:'Returning',
        swaping:'Exchange In Progress',
        returnSuccessful:'Return Successful',
        exchangeSuccessful:'Exchange Successful',
        returned:'Returned',
        swaped:'Exchanged',
        cancelReturn:'Cancel Return',

        frameNumber:'Frame Number',
        bikeCount:'E-Bike Count',
        shipDate:'Ship Date',
        extraDiscount:'Extra Discount (Unit Bike)',
        payTypeDiscount:'Payment Terms Discount',
        payTypeDiscount2:'Payment Discount 2',
        cargoFreight:'Freight Fee',
        cargoFreight2:'Freight',
        paymentType:'Payment Type',
        payWithDaysDiscountRate:'Cash Discount Ratio',
        paymentTypeDiscount:'Payment Terms Discount Ratio',
        paymentTypeDiscount2:'Payment Type Discount Ratio 2',
        payDay:'Payment Period',
        cashDiscountRatioDay:'Cash Discount Period',
        langTemplate:'Invoice Template',
        preTaxUnitPrice:'Excluding Tax Unit Price',
        preTaxDiscount:'Excluding Tax Discount (Unit Bike)',
        preTaxPayAmount:'Excluding Tax Pay Amount',
        preTaxExtraDiscount:'Excluding Tax Extra Discount (Unit Bike)',
        summary:'Amount Summary (Including Tax)',
        afterTaxUnitPrice:'Including Tax Unit Price',
        afterTaxDiscount:'Including Tax Discount (Unit Bike)',
        afterTaxPayAmount:'Including Tax Pay Amount',
        afterTaxExtraDiscount:'Including Tax Extra Discount (Unit Bike)',
        preTax:'Excluding Tax',
        afterTax:'Including Tax',
        preAfterTax:'Including/Excluding Taxes',
        orderExtraDiscount:'Extra Discount',
        discountRate:'Discount Rate',
        payWithin14daysDiscount:'Pay Within 14 days Discount',
        payWithin90daysDiscount:'Pay Within 90 days Discount',
        payWithin:'Pay Within ',
        daysDiscount:'days Discount',
        

        orderUse:'Order Use',
        backFlag:'Return Or Not',
        isReturn:'Return',
        notReturn:'Not Return',
        rollOverInventory:'Return Warehouse',
        exportOrder:'Export Order Data',
        exportEBike:'Export Order EBike',
        exportCustomer:'Export Order Details',
        exportUnshipOrder:'Export Unship Order',
        exportOrderData:'Order Data',
        exportEBikeData:'Order EBike Data',
        exportCustomerData:'Order Details Data',
        exportUnshipOrderData:'Unship Order Data',

        currentAmount:'Current Amount',
        refundReasonType:'Reason Type',
        refundReason:'Reason',
        payAmount2:'Pay Amount(Including Tax)',
        refundAmountVaildMsg:'The refund amount cannot be greater than the pay amount',

        greaterThan0:'need to be greater than 0',
        invoiceAddress:'Invoice Address',
        sameSKUExists:'Same SKU exists',
        instruction:'Remark',
        reissue:'Re-issue',
        replenishing:'Re-issue In Progress',
        reissueTimestamp:'Re-issue Date',
        reissueInfo:'Re-issue Information',
        reissueNumber:'Re-issue No.',
        reissueSuccessful:'Re-issue Successful',
        reissueType:'Re-issue Type',
        reissueQuantity:'Re-issue QTY',
        swapInventoryCode:'Re-issue Inventory Code',
        bom:'Bom Re-issue Inventory Code',
        selectProduct:'Please add re-issue product',
        reasonType:'Reason Type',
        reason:'Reason',
        reissueTimestamp:'Re-issue Date',
        stockQuantity:'Stock QTY',
        stockQuantityTip:'Stock QTY is 0',
        stockQuantityTip2:'Re-issue QTY greater than stock QTY',

        productQuantity:'Produce QTY',
        productQuantityErrorTip:'The produce quantity cannot be greater than the order quantity',
        createUser:'Create User',

        confirmProduct:'Please confirm the product information',
        frameColor:'Color',
        cancelSOConfirmTip:'Are you sure to cancel this line',
        createDate:'Create Date',

        orderType:'Order Sale Type',
        sale:'Sale Order',
        unSale:'Not Sale Order',

        customerNumber:'Channels Number',
        area:'Area',
        hfCustomerLevel:'Customer Level',
        paymentType:'Payment Type',
        paymentDay:'Payment Day',

        invoiceNo:'Invoice No.',
        userNote:'User Note',

        deliveryType:'Delivery Type',
        deliverConfirmTip1:'The order is unpaid. Please confirm if it has been shipped',
        deliverConfirmTip2:'The order is partial paid. Please confirm if it has been shipped',
        riskValidate:"Risk Validate",
        riskLevel:'Risk Level',
        confirmedAsRisk:"Confirmed as risk",
        relieveRisks:'Relieve risks',
        orderRisk:'Order Risk',
        riskLevel:'Risk Level',
        lowRisk:'Low',
        mediumRisk:'Medium',
        highRisk:'High',
        none:'None',
        isValid:'Confirmed',
        isRelieve:'Relieved',
        noValid:'Unconfirmed',
        confirmeSuccessful:'Confirme Successful !',
        relieveSuccessful:'Relieve Successful !',
        cancelSOHeadTip:'Only whole order cancellations can re edit order data, and some cancellations cannot edit orders.',
        logistics:'Logistics',

        downloadInvoiceMsg:'Orders can only be invoiced if they have been shipped and have a frame number.',

        // editOrderConfirmTip:'The order has been synchronized to ERP. Are you sure to edit it? If confirmed, please make synchronized modifications to the ERP system after editing the order. Otherwise, it will affect the accuracy of the data',
        editOrderConfirmTip:'The order has been synchronized to ERP. Are you sure to edit it?  ',
        editOrderConfirmTip1:'If confirmed, please make synchronized modifications to the ERP system after editing the order.  ',
        editOrderConfirmTip2:'Otherwise, it will affect the accuracy of the data.',
        editOrderConfirmTip3:'Please make synchronized modifications to the ERP system.',

        ECommerceVendor:'E-commerce Vendor',
        preInvoiceNo:'Create Invoice No. ToC',
        redownloadInvoice:'Redownload Invoice',
        downloadCustomDateInvoice:'Generate Order Invoice',
        downloadInvoiceTip:'If the content of the order has been updated, please click "Generate Order Invoice" to re-generate the content of the invoice.',
        invoiceDateTip:'You also can custom invoice date.',
        customerInfo2:'Customer Info',
        invoiceInfo:'Invoice Info',
        reSend:'ReSend',

        orderChannelType:'Order Type',
        invoiceTimestamp:'Invoice Date',
        shipWeek:'Predict Shipment Week',
        shipYear:'Predict Shipment Year',

        orderConfirmation:'ORDER CONFIRMATION',
        downloadConfirmation2:'Download Order Confirmation',
        downloadConfirmation:'Download Confirmation',
        sendConfirmation:'Send Confirmation',
        reDownloadConfirmation:'Generate Order Confirmation',
        downloadConfirmationTip:'If the content of the order has been updated, please click "Generate Order Confirmation" to re-generate the content of the order confirmation.',
    
        qty:'QTY',
        brandName:'Brand Name',
        partName:'Part Name',
        model:'Model',
        modelYear:'Model Year',
        modelYear2:'Year',
        modelModelYear:'Model/Model Year',
        day14Tip:'To encourage payment collection, the company will offer a 1% discount to customers who pay within 14 days using the "by invoice" payment method.',
        cancelDate:'Order Cancel Date',
        refundDate:'Order Refund Date',
        lineAmount:'Amount(Including Tax)',
        linePrice:'Unit Price',
        lineDepositAmount:'Deposit',

        lineQuantity:'Order',
        lineShipQuantity:'Shipping',
        lineBackQuantity:'Return',
        lineProductQuantity:'Product',
        InventoryQty:'Inventory QTY',

        orderLineMaxQtyTip:'Each order can only add up to 50 new lines',
        deliverOrderLineMaxQtyTip:'You can only select up to 15 rows at a time',

        priceTip1:'Unable to obtain the price of the vehicle, please resolve it through the following methods:',
        priceTip2:'【Method 1】Synchronize ERP price list in OMS system',
        priceTip3:'【Method 2】Please contact relevant personnel to maintain the price list in ERP first, and then synchronize the ERP price list in OMS system',
        syncNewPrice:'Sync Unit Price',

        defaultAddress:'Default Address',
        invoiceAddress:'Invoice Address',
        userNote:'User Note',

        lastValidOrderNo:'The last order number for this channel is: ',
        lastValidOrderNo2:'There are currently no orders for this channel.',
        exceedingMaxQty:'the number of orders that can be placed is ', // The number of orders that can be placed is    has a maximum order quantity of
        exceedingMaxQty2:' ,which has been exceeded currently!',
        prepaidCustomer:'Prepaid Customer',

        quantityNoZero:'The order quantity in the amount summary section cannot be 0. Please check or re-enter the order quantity in the order line!',

        tax:'Tax Rate',
        countryCode:'Country Code',
        createTax:'Create Tax Rate',

        syncUnitPriceTip:'Unit price minus discount does not equal payment amount, please check the data!',
        syncUnitPriceTip2:'It is already the latest unit price',

        recalculateAmount:'Recalculate',
        totalPaymentDiscount:'Total Payment Discount',
        totalFreight:'Total Freight',
        earliestShipTimestamp:'Earliest Shipping Date',
        earliestShipDateTip:'If the earliest shipping date is filled in, the order application shipping date cannot be earlier than that date !',
        shipDateTip:'The shipping date of the order cannot be earlier than the earliest shipping date !',
        dealerInactiveTip:'This dealer has been banned from ordering.  Please contact our sales team +49 (0) 8142 2844481 or',
        earliestShipDateTip2:'The earliest shipping date for this order is ',
        earliestShipDateTip3:', and the shipping date cannot be earlier than this time',
        earliestShipDateTip4:' ,so cannot apply for shipment at this time.',

        noShipTip:'At the current time, shipment is prohibited !',
        customerPaymentTypeTip:'Customer Payment type: ',

        orderDateCurMonthTip:'Orders can only be created in the current month. Please fill in the correct order date!',
        preShipmentYearTip:'Predict shipment year cannot be less than the order date year!',
        earliestShipmentDate:'Earliest shipping date cannot be less than the order date!',
        returnDateTip:'Return date cannot be earlier than the ship date!',
        returnDateTip2:'Return date cannot be earlier than the order date!',
        planDateTip:'Plan date cannot be earlier than the ship date!',
        planDateTip2:'Plan date cannot be earlier than the order date!',
        refundDateTip:'Refund date cannot be earlier than the order date!',
        reissueDateTip:'Re-issue date cannot be earlier than the order date!',
        orderNameRuleTip:'The order name does not comply with the rules. Naming rules: supports entering uppercase and lowercase English letters (excluding "O" and "o"), numbers, -, #, with a length of 6-50.',
        orderNameRuleTip2:'The order name does not comply with the rules. Naming rules: supports entering uppercase and lowercase English letters, numbers, -, #, with a length of 6-50.',

        EBikeOrderName:'EBike Order No.：',
        service:'Service',
        serviceOrder:'Service Order',
        ebikeOrder:'E-Bike Order',
        noNeedToShip:'No shipping required',
        createServiceOrder:'Create Service Order',
        shipQty:'Ship Qty',
        bindSku:'E-Bike SKU',
        signTime:'Sign Time',
        serviceOrdreLineQtyTip:'The insured quantity cannot exceed the total number of bike in the order line',
        serviceCount:'Insure Qty',
        serviceOrderDateTip:'The order date must be 14 days after the order signing date',

        autoComputeFreight:'The freight fees rules have been changed. Click confirm, orders created between January 15, 2025 and February 7, 2025 will have their freight fees automatically calculated according to the new rules.',
        freightConfirm:'Freight rule change',

        orderConfirmMail:'Order Confirm Email',
        emailFormatTip:'The email format is incorrect!',

        virtual:'Virtual',
        c2c:'C&C',
        confirmVirtualOrder:'Confirm Virtual Order',
        virtualOrder:'Virtual Order',
        c2cExtraAmount:'Click&Collect 5%',

        secondHandFlag:'Second Hand E-Bike',
        orderCategory:'Order Category',
        customerObjByPickUpIdTip:'The customer information cannot be obtained and the acquisition of 【source_id】 failed',

        editUserNote:'Edit User Note',

        openPosition:'Open Position',
        priceList:'Price List',
        openPositionData:'Open Position Data',
        priceListData:'Price List Data',

        customerNumber:'Customer ID/Dealer ID',
        orderNumber:'Order NO.',
        shipmentNotificationNumber:'Shipment Notification NO.',
        invoiceNumber:'Invoice NO.',
        invoiceDate:'Invoice Date',
        dueDate:'Due Date',
        amountTotal:'Amount Total',
        amountPaid:'Amount Paid',
        paid:'Paid',
        payStatus:'Pay Status',
        
        bike:'Bike',
        part:'Part',
        normal:'Normal',

        orderCategoryTip:'The order category can only be modified after clearing the SKU in the order line.',

        standard:'Standard',
        express:'Express',
        deliveryTimeliness:'Express Delivery Timeliness',

        b2bCargoFreightTip:'B2B Shop Order Freight',
        deliveryTimelinessTipContent:'The express delivery timeliness cannot be selected when the country is not Germany, Austria. Please reselect the delivery timeliness.'
    },
    prepaidOrder:{
        createPrePaidOrderSuccess:'Successfully created prepayment order !',
        invalidate:'Invalidate',
        downloadInvoice:'Download Invoice',
        rebuildInvoice:'Rebuild Invoice',
        sendInvoice:'Send Invoice',
        invalidateTip:'Are you sure to change the prepayment order to invalid ?',
        sendInvoiceTip:'Are you sure to send the invoice for the prepayment order to the customer ?',
        validityStatus:'Validity Status',
        valid:'Valid',
        invalid:'Invalid',
        unbind:'Unbind',
        unbindTip:'Are you sure to unbind the outbound order?',
        createPrepaidOrder:'Create Prepaid Order',

       
    },
    B2BShopOrder:{
        confirm:'Confirm',
        verifyStatus:'Confirm Status',
        unconfirm:'Unconfirmed',
        confirmed:'Confirmed',
        partiallyConfirmed:'Partially Confirmed',
    },
    dealerOpenOrder:{
        sku:'SKU',
        categoryCode:'Type',
        modelYear:'Model Year',
        model:'Model',
        orderNumber:'Order No.',
        customerNumber:'Customer ID/Dealer ID',
        orderChannelType:'Channels',
        orderTimestamp:'Order Date',
        quantity:'Quantity',
        amount:'Amount',
        deliveryBlock:'Delivery Block',
        normal:'Normal',
        bike:'Bike',
        parts:'Parts',
        openAmount:'open',
        totalAmount:'total',
        totalQty:'total',
        unshipQty:'unship',
        dealerOpenOrderData:'Dealer Open Order Data',
        exportExcel:'Export Excel',
        exportAllExcel:'Export All',
        description:'Description',
        erpSoNo:'ERP SO. No.',
        orderStatus:'Order Status',
        shipmentStatus:'Shipment Status',
        available:'Available',
        unavailable:'Unavailable',
        plan_start_timestamp:'Shipping start date',
        plan_end_timestamp:'Shipping end date',
        asm:'ASM',
    },
    preSaleOrder:{
        importConfig:'Import Configuration',
        dealerName:'Dealer Name',
        paymentType:'Payment Type',
        paymentDay:'Payment Period',
        paymentTypeDiscount:'Payment Terms Discount Ratio',
        payWithDaysDiscountRate:'Cash Discount Ratio',
        taxRate:'Tax Rate',
        invoiceAddress:'Invoice Address',
        shippingAddress:'Shipping Address',
        country:'Country',
        winterFinancing:'Winter Financing',
        paymentPeriod:'Payment Period',
        cashDiscountPeriod:'Cash Discount Period',
        loadSampleData:'Load Sample Data',
        configImport:'Configure Import',
        saveOrder:'Save Orders',
        tip1:'Please upload Excel file (.xlsx, .xls, .xlsm)',
        title1:'Split Order Results',
        availableSKUs:'Available SKUs',
        unavailableSKUs:'Unavailable SKUs',
        unknownSKUs:'Unknown SKUs',
        nopriceSKUs:'No Price SKUs',

        availableSKUsOrders:'Available SKUs Orders',
        unavailableSKUsOrders:'Unavailable SKUs Orders',
        unknownSKUsOrders:'Unknown SKUs',
        nopriceSKUsOrders:'No Price SKUs',

        bikeCount:'Bike Count：',

        orderNo:'Order No.',
        bikeQty:'Bike QTY',
        skuQty:'SKU QTY',
        deliveryDateByCustomer:'Delivery Date By Customer',
        shippingCostNoTax:'Shipping Cost',
        taxRate:'Tax Rate',
        paymentTypeDiscountAmountNoTax:'Payment Discount',
        netAmount:'Net Amount',
        taxAmount:'Tax Amount',
        total:'Total',
        payWithDaysDiscountAmountInTax:'Pay With Days Discount(In Tax)',
        
        sku:'SKU',
        model:'Model',
        quantity:'Quantity',
        size:'Size',
        color:'Color',
        type:'Type',
        orderType:'Order Type',
        shippingMonth:'Shipping Month',
        expectedShippingDate:'Expected Shipping Date (By Customer)',
        expectedDelivery:'Expected Delivery',
        totalQty:'Total QTY',
        unitPrice:'Unit Price',
        eta:'ETA',
        overdue:'Overdue',

        deliveryInfo:'Delivery Info',


        category:'Category',
        articleNumber:'Article Number',
        model:'Model',
        description:'Description',
        dealerPrice:'Dealer Price',
        totalUnits:'Total (Units)',

        downloadTemplate:'Download Template',
        orderDetail:'Order Detail',
        oderNameTip:'This is the detailed information of the created order. Please go to the "Orders" page to view it.',
        saveTip:'The file has become invalid. Please reselect the file.',

        discount:'Discount',
        payAmount:'Pay Amount',
        preDiscountRate:'Pre Discount Rate',
    },
    approval:{
        basicInfo:'Basic Information',
        approvalRecord:'Approval Record',
        deleteFilters:'Delete all filters',
        customerName:'Customer Name',
        customerNumber:'Customer ID/Dealer ID',
        orderNumber:'Order No.',
        orderAmount:'Order Amount',
        quantity:'E-bike quantity',
        instanceCode:'Serial No.',
        initiationDate:'Initiation Date',
        overdueStatus:'Overdue status',
        businessOrderTimestamp:'Order date',
        businessOrderAmount:'Order amount',
        customerUnpaidAmount:'Unpaid amount',
        customerCreditQuota:'Credit quota',
        status:'Status',

        approval:'Approval',
        detail:'Detail',
        refuse:'Reject',
        closed:'Closed',
        close:'Close',
        adopt:'Adopt',
        approve:'Approve',

        pending:'Pending',
        rejected:'Rejected',
        cancel:'Cancel',
        finish:'Finish',

        node:'Node',
        approver:'Approver',
        results:'Results',
        comments:'comments',
        approvalTime:'Approval time',

        history_amount:'History Transaction Amount',
        customer_unpaid_amount:'Unpaid Amount',
        maximum_overdue_days:'Maximum Overdue Days',
        overdue_situation :'Payments situation in the last three months ',
        insolvency_index:'Insolvency Index',
        customer_payment:'Payment Method',
        credit_file:'Credit Report Upload',
        credit_file2:'Credit Report',
        sale_instruction:'Note',

        business_order_name:'Order Name',
        customer_name:'Customer Name',
        customer_number:'Customer ID/Dealer ID',
        business_order_amount:'Order Amount',
        business_order_bike_quantity:'E-bike Quantity',
        customer_credit_quota:'Customer Credit Quota',
        
        fileType:'Supports zip, pdf, doc, xlsx types, with a maximum uploaded file size of 10M',
        days:'Days',

        approveTip:'Are you sure you want to adopt it?',
        refuseTip:'Are you sure you want to reject it?',
        closeTip:'Are you sure you want to close it?',

        approvalSuccess:'Approval successful, order has been approved',
        approvalRefuse:'The order has been rejected',
        approvalClose:'The order has been closeed',

        nodeCode:'Node',
        userName:'Approve',
        statusRes:'Results',
        createTimestamp:'Approval time',

        approvalRecord:'Approval Record',
        approved:'Approved History',
        pendingApproval:'Pending Approval',
        downloading:'Downloading...',

        nodeBegin:'Approval begin',
        nodeFinance:'Finance approval',
        nodeSale:'Sales director approval',
        nodeCEO:'CEO approval',
        nodeEnd:'Approval end',
        currentNodeCode:'Current processor',
        ceo:'CEO',
        finance:'Finance',
        sale:'Sales Director',
        beginDate:'Begin Date',
        endDate:'End Date',
    
    },
    dealerPreOrder:{
        businessOrderName:'Pre Order No.',
        customerLevel:'Customer Level',
        amount:'Amount',
        ordered:'Ordered',
        confirm:'Confirm',
        cancel:'Cancel',

        bronze:'Bronze',
        silver:'Silver',
        gold:'Gold',
        platinum:'Platinum', 

        categoryType:'Product Type',
        price:'Unit Price',

        standard:'Standard',
        express:'Express',
        collection:'Self-picked',

        modelYear:'Model Year',
        modelVersion:'Model & Version',
        confirmStatus:'Confirm Status',
        frameColor:'Color',
        frameShape:'Frame',
        frameSize:'Size',
        orderOperatetype:'Order Type',
        operateWhole:'E-bike',
        operatePart:'Parts',

        close:'Close',
        userNote:'User Note',
        creditValidate:'Credit Validate',
        validateSuccess:'Pass',
        validateFail:'Fail',
        closeSuccess:'The order has been closed',
        closeOrderTip:'Are you sure to close the order?',
        verifyConfirm:'Verify and Confirm',
    },
    stock:{
        transactionDate:'Plan Shipping Date',
        deliveryDate:'Real Shipping Date',
        signTime:'Delivered Date',
        quantity:'Quantity',
        orderQty:'Order',
        shipQty:'Actual Ship',
        plan:'Plan',
        real:'Real',
        signFor:'Delivered',
        signForDate:'Delivered Date',
        signForSuccess:'Delivered SuccessFully',
        outboundOrderBikeQuantity:'Outbound Order E-Bike Quantity',
        unoutboundBikeQuantity:'Unoutbound E-Bike Quantity',
        outboundBikeQuantity:'Outbound E-Bike Quantity',
        cargoFreight:'Freight Fee',
        contentTip:'The editing content cannot be empty',
        contentTip2:'The ship logistics No. or ship logistics URL cannot be empty',
        contentTip3:'The return logistics No. or return logistics URL cannot be empty',
        logistics:'Logistics',
        returnLogistics:'Return Logistics',
        logisticsType:'Type',
        logisticsNo:'No.',
        logisticsLink:'URL',
        deliveryNumber:'Outbound No.',
        // deliveryNumber:'Shipment Notification No.',
        remark:'Remarks',
        cargoFreight:'Freight Fee',
        frameNumber:'Frame Number',
        confirmFrameNumber:'Confirm whether to modify the frame number?',
        po:'PO.',
        outboundDate:'Shipping Date',
        brandPartName:'Brand/Part Name',
        brandName:'Brand',
        partName:'Part',
        modelModelYear:'Model/Model Year',
        modelYear:'Year',
        returnDate:'Return Date', 

        shipment:'Shipment',
        return:'Return',
        exchange:'Exchange',
        reissue:'Re-issue',
        returnFactory:'Return Factory',
        backTimestamp:'Back',
        backRealTimestamp:'Receive',
        backDate:'Plan Return Date',
        backReceiveDate:'Real Return Date',
        swapTimestampPlan:'Plan',
        swapTimestampReal:'Real',
        swapDatePlan:'Plan Shipping Date',
        swapDateReal:'Real Shipping Date',
        returnStatus:'Return Status',
        swapStatus:'Exchange Status',
        backQty:'Back QTY',
        swapNumber:'Shipment No.',
        swapQty:'Exchange QTY',
        swapLogistics:'Exchange Logistics',
        reissueNumber:'Re-issue No.',
        reissueStatus:'Re-issue Status',
        reissueQty:'Re-issue QTY',
        cancelOutbopundConfirmTip:'This operation will cancel the outbound of all products under the outbound order',
        cancelSwapConfirmTip:'Are you sure to cancel the exchange order',
        cancelReturnConfirmTip:'Are you sure to cancel the return order',
        cancelReissueConfirmTip:'Are you sure to cancel the re-issue order',
        cancelOutbound:'Cancel',
        cancelOutbound2:'Cancel Outbound',
        cancelSwap:'Cancel',
        cancelSwap2:'Cancel Exchange',
        cancelReturn:'Cancel',
        cancelReturn2:'Cancel Return',
        cancelReissue:'Cancel',
        cancelReissue2:'Cancel Re-issue',
        shipmentDetail:'Shipment Detail',
        returnDetail:'Return Detail',
        exchangeDetail:'Exchange Detail',
        reissueDetail:'Re-issue Detail',
        image:'Images',
        exportShipment:'Export',
        exportShipment2:'Export （F.D）',
        exportShipmentData:'Outbound Order Data',
        exportShipmentData2:'Outbound Order Data (F.D)',
        exportConfirmTip:'Are you sure to export?',

        exportReturnData:'Return Order Data',
        exportExchangeData:'Exchange Order Data',
        exportReissueData:'Re-issue Order Data',
        exportReturnFactoryData:'Return Factory Order Data',

        returningFactory:'Returning Factory',
        returnFactorySuccessful:'Return Factory Successful',
        returnFactoryNumber:'Return Factory No.',
        returnFactoryStatus:'Return Factory Status',
        returnFactoryQty:'Return Factory QTY',
        returnFactoryDetail:'Return Factory Detail',

        bikeCount:'unoutbound e-bike count',
        bikeCount1:'returning e-bike count',
        bikeCount2:'exchange in progress e-bike count',
        bikeCount3:'re-issue in progress e-bike count',
        bikeCount4:'returning factory e-bike count',
        bomCount:'unoutbound bom count',
        bomCount1:'returning bom count',
        bomCount2:'exchange in progress bom count',
        bomCount3:'re-issue in progress bom count',
        asOf:'The plan shipping time is as of ',
        asOf2:'As of ',

        categoryType:'Category Type',

        planShipStartDate:'Plan Ship Start Date',
        planShipEndDate:'Plan Ship End Date',
        realShipStartDate:'Real Ship Start Date',
        realShipEndDate:'Real Ship End Date',

        planReturnStartDate:'Plan Return Start Date',
        planReturnEndDate:'Plan Return End Date',
        realReturnStartDate:'Real Return Start Date',
        realReturnEndDate:'Real Return End Date',

        swapCourierType:'Ship Courier Type',
        swapCourierNo:'Ship Courier No.',
        swapCourierLink:'Ship Courier Link',
        swapCourierStatus:'Ship Courier Status',
        returnCourierType:'Return Courier Type',
        returnCourierNo:'Return Courier No.',
        returnCourierLink:'Return Courier Link',
        returnCourierStatus:'Return Courier Status',

        returnLogisticsInfo:'Return Logistics Information',
        swapLogisticsInfo:'Ship Logistics Information',

        outScanned:'Scanned',
        deliveryNote:'DELIVERY NOTE',
        deliveryNote2:'Delivery Note',

        swapSku:'Exchange SKU',
        zuExportShipment:'Export Excel',
        sendEmailToZU:'Send shipment email to ZU',
        sendEmailToZUTip:'When entering multiple email addresses, please separate them with commas',

        addFrameNo:'Add/Edit Frame No.',
        cancelReturnFactory:'Cancel Return Factory',
        
    },
    inventoryLock:{
        sku:'SKU',
        total:'Total',
        inStock:'In Stock',
        inTransit:'In Transit',
        productionPlan:'Production Plan',
        availabilityQTY:'Availability QTY',
        availableQTY:'Available QTY',
        lockedQTY:'Locked QTY',
        type:'Type',
        inventoryType:'Inventory Type',
        warehouse:'Warehouse',
        totalLockedQTY:'Total Locked QTY',
        currentLockedQTY:'Current Locked QTY',
        shippedQTY:'Shipped QTY',
        shippingQTY:'Shipping QTY',
        estimatedShippingDate:'Estimated Shipping Date',
        estimatedShippingDateByCustomer:'Estimated Shipping Date(By Customer)',
        ETA:'ETA',
        quantity:'Quantity',
        locked:"Locked",
        view:'View',
        inventoryLockInfo:'Inventory Lock Information',
        orderName:'Order NO.',
        lockStatus:'Lock Status',
        finish:'Finished',
        reserved:'Reserved',
        overdue:'Expired',
        refresh:'Refresh',
        total2:'total',
        ship:'shipped',
        deliveryDateList:'Estimated Delivery Date List',
        currentQTY:'Current Order Locked Quantity',
        unlockInventory:'Unlock inventory',
        avaInventoryList:'Available Inventory List',
        orderInventoryLockList:'Order Inventory Lock List',
        currentLockedQTYTip:'The 【Current Locked QTY】 cannot be greater than the 【Availability QTY】 !',
        sameData:'The same data already exists !',
        unlockedTip:'The number of shipped products exists and cannot be unlocked !',
        inventoryLockDetail:'Inventory Lock Detail',
        lockInventory:'Lock Inventory',
        releaseInventory:'Release Inventory',
        inventoryLockList:'Inventory Lock List',
        released:'Released',
        isOccupy:'Whether To Occupy',
        batchId:'Batch ID',
        lockTip:'Confirm whether to lock inventory?',
        releasedTip:'Confirm whether to released inventory?',
        lockSuccessful:'Lock Successfully !',
        releaseSuccessful:'Release Successfully !',
        editUnlockTip:'The inventory lock must be unlocked first !',
        shipInStockTip:'Please confirm that the E-Bike inventory is locked before shipment commences.',
        skuOrderQty:'SKU Order Quantity: ',
        openQty:'Open Quantity: ',
        shipInStockTip2:'【Total Locked QTY】 cannot exceed the quantity of SKU orders placed.',
        currentLockedQTY2:'【Current Locked QTY】needs to be greater than 0',
        inventoryLockData:'Inventory Lock Data',
        batchId:'Batch ID',
        etaTip:'The batch has expired. Please fill it in again !'
    },
    warning:{
        wms:'Warehouse',
        deliveryNumber:'Outbound No.',
        // deliveryNumber:'Delivery No.',
        warningTimestamp:'Warning Date',
        warningType:'Warning Type',
        warningStatus:'Warning Status',
        createDate:'Create Date',
        updateUser:'Update User',
        detail:'Detail',
        warning:'WARNING',
        error:'ERROR',
        changeToError:'Change To ERROR',
        qty:'QTY',
    },
    returnOrder:{
        createReturnOrder:'Create Return Order',
        selectProduct:'Select Product',
        selectProductMsg:'Please select product',
        returnDate:'Return Date',
        returnStartDate:'Return Start Date',
        returnEndDate:'Return End Date',
        courierType:'Courier Type',
        courierNo:'Courier No.',
        returning:'Returning',
        returnSuccesful:'Return SuccessFully',
        backNumber:'Return No.',
    },
    invoice:{
        create2CInvoice:'Create To C Invoice',
        create2BInvoice:'Create To B Invoice',
        download:'Download',
        reDownload:'Re-Download',
        reGenerate:'Re-Generate',
        send:'Send',
        reSend:'Re-Send',
        sending:'Sending...',
        delete:'Delete',
        invoiceNo:'Invoice No.',
        orderName:'Order No.',
        invoiceChildType:'Outbound No.',
        orderChannelType:'Invoice Type',
        orderType:'Order Type',
        invoiceAmount:'Invoice',
        createDate:'Invoice Date',
        updateDate:'Update Date',
        deliveryNumber:'Shipment Notification No.',
        outboundStatus:'Outbound Status',
        frameNumber:'Frame Number',
        unOutbound:'UnOutbound',
        outbound:'Outbound',
        cancelOutbound:'Cancel Outbound',
        outScanned:'Scanned',
        quantity:'Quantity',
        orderDate:'Order Date',
        deliveryDate:'deliveryDate',
        doubleInvoiceMsg:'There is already an invoice for this order, please do not double invoice it.',
        deleteMsg:'Delete the invoice? (After deletion, if you want to regenerate the invoice, please click "Create").',
        sendInvoiceMsg:'Are you sure to send the invoice to the customer? The customer can download the invoice for preview',
        reGenerateInvoice:'Re-Generate Invoice',
        orderQty:'Order Qty',
        shipQty:'Ship Qty',
        downloadInvoiceTip:'If the content of the order has been updated, please click "OK" to re-generate the content of the invoice.',
        invoiceVaildStatus:'Invoice Status',
        vaild:'Vaild',
        invaild:'Pre Invoice/Invaild',
        payStatus:'Payment Status',
        payAmount:'Pay Amount',
        payAmount2:'Pay',
        amount:'Amount',
        payAmountTip:'If the difference between the payment amount and the invoice amount is less than 0.5 euros, it will be considered as full payment',
        exportInvoice:'Export Excel',
        exportInvoiceData:'Invoice Data',

        normalInvoice:'Order Invoice',
        prepaidInvoice:'Proforma Invoice',
        selectInvoiceType:'Select Invoice Type',
        selectInvoiceTypeTip:'Please select invoice type',
        invoiceType:'Invoice Type',
    },
    plan:{
        importFile:'Impport Plan Data',
        exportFile:'Export Plan Data',
        downloadTemplate:'Download File Template',
        quantity:'Quantity',
        recordDate:'Plan ETA',
        recordYear:'Year',
        recordWeek:'Week',
        inventoryCode:'Inventory Code',
        remark:'Remark',
        createTimestamp:'Create Date',
        productName:'Product Name',
        hasSku:'The same SKU already exists',
        planData:'Product Plan Data',
        importSuccess:'Import successfully!',
        importing:'Importing ...',
        importFail:'Import failed',
        downloadTemplateSuccess:'Template download successfully!',
        deleteTip:'Are you sure you want to delete it?',
        sourcePo:'PO.',
        factory:'Factory',
        recordMonth:'Month',
        restQuantity:'Rest QTY',
        processCode:'Process Code',
        versionCode:'Version Code',
        splitDelivery:'Split Delivery',
        splitOrder:'Split Order',
        inStockQuantity:'In Stock QTY',
        deliveryDate:'Delivery Date',
        selectSKU:'Please Select Correct SKU',
        inTransitQuantity:'In Transit QTY',
        recordDate:'Record Date',
        record:'History Record',
        maisachEdit:'Maisach Plan Edit',
        quantityTip:'The sum of the quantity of rows cannot exceed the quantity of the original SKU',
        quantityTip2:'The quantity of rows cannot be less than the rest quantity of rows',
        quantityTip3:'The quantity of rows cannot be less than the in stock quantity of rows',
        quantityTip4:'The quantity of rows cannot be less than the in transit quantity of rows',
        quantityTip6:'The sum of the quantity of rows does not equal the quantity of headers. Please check !',
        
        restQtyTip:'The sum of the rest quantity of rows cannot exceed the rest quantity of headers',
        restQtyTip2:'The sum of the rest quantity of rows does not equal the rest quantity of headers. Please check !',

        inStockQtyTip:'The sum of the in stock quantity of rows cannot exceed the in stock quantity of headers',
        inStockQtyTip2:'The sum of the stock quantity of rows does not equal the stock quantity of headers. Please check !',

        inTransitQtyTip:'The sum of the in transit quantity of rows cannot exceed the in transit quantity of headers',
        inTransitQtyTip2:'The sum of the transit quantity of rows does not equal the transit quantity of headers. Please check !',

        quantityTip5:'The in transit quantity of rows cannot be less than the in stock quantity of rows',
    },
    returnExchange:{
        // create:'创建退换货单',
        returnAndExchange:'Return & Exchange',
        returnAndExchange2:'Return & Exchange & Re-issue',
        returnExchange:'Return/Exchange',
        returnExchangeRecord:'Return Record',
        returnExchangeRecord2:'Return/Exchange',
        exchangeRecord:'Exchange Record',
        reissueRecord:'Re-issue Record',
        type:'Type',
        status:'Status',
        erpNo:'ERP No.',
        erpLineNo:'ERP Line No.',
        // source:'Source',
        source:'Channels',
        customerErpCode:'ERP Code',
        quantity:'Quantity',
        discount:'Discount',
        sku:'SKU',
        productName:'Product Name',
        inventoryCode:'Inventory Code',
        backTimestamp:'Back Date',
        backRealTimestamp:'Back Real Date',
        backReasonType:'Reason Type',
        backReason:'Reason',
        swapReasonType:'Exchange Reason Type',
        swapReason:'Exchange Reason',
        ibsVerificationType:'IBS Verification Type',
        ibsVerificationPlan:'IBS Verification Plan',
        customerName:'Customer Name',
        backNumber:'Return No.',
        swapNumber:'Shipment No.',
        swapInventoryCode2:'Bike Exchange Inventory Code',
        swapInventory:'Exchange Inventory',
        swapQuantity:'Exchange Quantity',
        swapTimestampPlan:'Exchange Plan Date',
        swapTimestampReal:'Exchange Real Date',
        courierNo:'Logistics No.',
        courierType:'Logistics Type',
        swapCourierNo:'Logistics No.',
        swapCourierType:'Logistics Type',
        return:'Return',
        exchange:'Exchange',
        exchangeCourierNo:'Exchange Logistics No.',
        exchangeCourierType:'Exchange Logistics Type',
        exchangeCourierStatus:'Exchange Logistics Status',

        returnFactoryInfo:'Return Factory Information',
        returnFactoryReasonType:'Reason Type',
        returnFactoryReason:'Reason',
        backTimestamp:'Back Date',
        returnFactoryQty:'Return Factory QTY',
        returningFactoryQty:'Returning Factory QTY',
        returningFactory:'Returning Factory',
        returnFactorySuccessful:'Return Factory Successful',
        returnFactoryTimestampPlan:'Plan Date',
        returnFactoryCourierNo:'Logistics No.',
        returnFactoryCourierType:'Logistics Type',  
        returnFactoryTimestampPlan2:'Return Factory Plan Date',
        returnFactoryTimestampReal:'Return Factory Real Date',
        returnFactoryCourierNo2:'Return Factory Logistics No.',
        returnFactoryCourierType2:'Return Factory Logistics Type',
        returnFactoryCourierStatus:'Return Factory Logistics Status',
        selectReturnFactoryProduct:'Please select a return factory product',
        returnFactoryRecord:'Return Factory Record',
        returnFactoryNumber:'Return Factory No.',
        returnFactoryInventoryCode:'Return Factory InventoryCode',
        exceedingReturnFactoryQty:'Exceeding the repairable quantity',

        initial:'Initial',
        returning:'Returning',
        exchangeProgress:'Exchange In Progress',
        returnSuccessful:'Return Successful',
        exchangeSuccessful:'Exchange Successful',

        baseInfo:'Base Information',
        returnInfo:'Return Information',
        exchangeInfo:'Exchange Information',
        orderLineInfo:'Order Line Information',

        backCourierNo:'Back Logistics No.',
        backCourierType:'Back Logistics Type',
        backCourierStatus:'Back Logistics Status',
        swapCourierNo:'Exchange Logistics No.',
        swapCourierType:'Exchange Logistics Type',
        bomCategory:'Bom Category',
        bom2:'Bom Exchange Inventory Code',
        bike:'Bike',
        bom:'Bom',
        swapType:'Exchange Type',
        courierStatus:'Logistics Status',
        warehouse:'Warehouse',
        inventoryRemark:'Common Material Remark',

        swapInventoryCode:'Exchange Inventory Code',
        swapInventory:'Exchange Inventory',
        swapQuantity:'Exchange QTY',
        backQuantity:'Back QTY',
        returnedQuantity:'Returned QTY',
        exceedingQuantity:'Exceeding the refundable quantity!',
        exceedingDiscount:'Exceeding the order discount amount, please fill in again!',
        seeFile:'Attachments',
        selectProduct:'Please select a return product',

        imgLimit:'Uploading images cannot exceed 5M',
        imgLimit2:'The image format is incorrect. Please upload a .jpg/.jpeg file',
        uploadDesc:'Upload up to 3 images, each image cannot exceed 5MB, only supports .jpg/.jpeg files',
        uploadFail:'Failed to upload image',

        deliveryDate:'Ship Date',
        backFactory:'Back Warehouse',
    },
    product:{
        sku:'SKU',
        inventoryCode:'ERP Product Code',
        chineseName:'Product Name(Zh)',
        englishName:'Product Name',
        germanName:'Product Name(De)',
        franceName:'Product Name(Fr)',
        torque:'Torque',
        inventory:'Inventory',
        frame:'Frame',
        createDate:'Create Date',
        model_year:'Model Year',
        model:'Model',
        frameShape:'Frame',
        frameSize:'Size',
        frameColor:'Color',
        unitWeight:'Weight',
        weightUomCode:'Weight Unit',
        hfVersion:'Version',

        addProduct:'Add Product',
        editProduct:'Edit Product',
        skuTip:'SKU cannot be empty!',
        inventoryCodeTip:'The material code cannot be empty!',
        englishNameTip:'Product name (English) cannot be empty!', 
        torqueTip:'Torque cannot be empty!',
        frameTip:'The frame cannot be empty!',

        sync:'Synchronous',
        syncTip:'Click Sync button to update product information to historical orders',
        warehouse:'Warehouse',
        delConfirmTip:'Are you sure to delete?',

        categoryName:'Category Name',
        inventoryItemStatusCode:'Status',
        syncERPToOrder:'Sync ERP Product',
        schedulingQuantity:'Planned Outbound QTY',

        torqueSizeColorWeight:'Torque/Size/Color/Weight',
        modelYearModel:'Model/Model Year',

        exportFile:"Export Excel",
        productData:"Product Data",

        brandName:'Brand Name',
        partName:'Part Name',
        model:'Model',
        modelYear:'Model Year',
        stockSum:'Total QTY',
        warehouseInventory:'Warehouse Inventory',
        schedulingQty:'Reserved Detail',
        schedulingTotalQty:'Reserved QTY',
        availabilityQty:'Real Availability',
        trekking7:'Trekking 7 MY24',
        mountain7:'Mountain 7 MY24',
        trekking7Carbon:'Mountain 7 Carbon MY24',
        trekking7MY23:'Trekking 7 MY23',
        ebikeInventory:'E-Bike Inventory Data',
        ebikeInventorySummary:'E-Bike Inventory Summary Data',
        resetTableFilter:'Reset Filters',

        syncERPToOrderTip:'The current vehicle BOM is not fully synchronized. Click "OK" to synchronize the BOM.',
    
        version:'Version',
        zu:'ZU',
        hepha:'Maisach',
        ToBeProduced:'Need To Be Produced',
        centralWarehouse:'Central Warehouse',
        TTL:'TTL',
        backOrder:'Back Order',
        modelSummary:'Summary',
        inventoryAge:'Inventory Age',

        toBeDelivered:'To Be Delivered',
        deliveryPlan:'Delivery Plan',
        supply:'Supply CWH',
        endOfMonthInventory:'End-of-Month Inventory',
        overdueUnavailable:'Overdue Unavailable',
        yearEndUnshippable:'Year-end Unshippable',
        initialInventory:'Initial Inventory',
        stock:'Stock, Finished bike in Germany auto updated from mail',
        itemCode:'Item Code',
        maisach:'Maisach',
        cwh:'CWH',
        frameSize2:'Frame Size',
        frameType2:'Frame Type',
        frameShape2:'Frame Shape',
        frameColor2:'Frame Color',
        transit:'Transit',
        Jan:'Jan',
        Feb:'Feb',
        Mar:'Mar',
        Apr:'Apr',
        May:'May',
        Jun:'Jun',
        Jul:'Jul',
        Aug:'Aug',
        Sep:'Sep',
        Oct:'Oct',
        Nov:'Nov',
        Dec:'Dec',

        availabilityReportData:'Availability Report Data',
        endWeekTip:'The end week cannot be less than the begin week!',

        active:'Active',
        inActive:'InActive',
        activeStatus:'Active Status',

        placeOrder:'Place Order',
        cancelPlaceOrder:'Cancel Place Order',
        quantity:'Quantity',
        expectETADate:'Expected ETA Date',

        finishedPacking:'ZU Finished Packing',
    },
    customer:{
        customerName:'Customer Name',
        customerNameNew:'Name(OMS Maintenance)',
        customerName2:'Customer Name2',
        customerType:'Type',
        customerEmail:'Email',
        customerPhone:'Phone',
        customerCountry:'Country',
        customerCity:'City',
        customerState:'State',
        customerAddr:'Address',
        customerAddr2:'Address 2',
        createDate:'Create Date',
        updateDate:'Update Date',
        zip:'Zip Code',
        billingAddress:'Billing Address',
        addressType:'Address Type',
        defaultAddress:'Default Address',
        invoiceAddress:'Invoice Address',
        source:'Channel(ERP Maintenance)',
        customerErpCode:'Customer ID/Dealer ID',
        contactName:'Company Name\\Contact Name',
        contactName2:'Contact Name2',
        contactName3:'Company/Contact Name',
        contactNameNew:'Contact Name(OMS Maintenance)',
        companyName:'Company Name',
        contactName2:'Contact Name',

        user:'User',
        dealer:'Dealer',
        addCustomer:'Add Customer',
        editCustomer:'Edit Base Information',
        editAddressCustomer:'Edit Address Information',
        syncERPChannels:'Sync ERP Channels',

        sex:'Gender',
        male:'Male',
        female:'Female',
        unknown:'Unknown',

        companyAddress:'Company Address',
        storeAddress:'Store Address',
        pickUpAddress:'Pick Up Address',
        baseInfo:'Base Information',
        addressInfo:'Delivery Address Information',
        addressInfo2:'Invoice Address Information',
        customerEmailFormatError:'Incorrect email format!',
        orderConfirmMailFormatError:'Incorrect order confirm email format!',

        addCustomerAddress:'Add Customer Address',
        differentAddrTip:'The invoice address is different from the default address',
        firstAddress:'Set As The First Address',
        firstAddress2:'First Address',

        emailServiceFlag:'Provide Email',

        addLocation:'Add/Edit B2B Location',
        addPickUpLocation:'Add/Edit C&C Pickup Location',
        editLocation:'Edit Location',
        editPickUpLocation:'Edit C&C Pickup Location',
        locationName:'Location Name',
        pickUplocationName:'Pickup Location Name',
        shippingAddress:'Shipping Address',
        invoiceAddress:'Invoice Address',
        baseAddress:'Address',
        firstName:'First Name',
        lastName:'Last Name',
        country: 'Country',
        city: 'City',
        zip: 'Zip Code',
        eabledFlag: 'Enabled',
        contactForB2BShopLogin:'Contact for B2B shop login',
        firstNameTip:'Please fix the selected customer address information then add new B2B shop dealer location information.',

        editCustomerAddressTip:'Edit Customer Address',
        editErpCodeTip:'Assigned Sub ERP Code',
        dealerErpCode:'Sub ERP Code',
        enterERPCode:'Please Enter',
        subErpCodeTip:'Format error! correct format: ODE0001-XXXX，XXXX： Composed of 3 to 4 digits or uppercase letters',
        subErpCodeTip2:'Example of correct format: ODE0001-XXXX，XXXX： Composed of 3 to 4 digits or uppercase letters',
        deleteSubERPCodeTip:'Delete Sub ERP Code',
        deleteLineTip:'Delete Customer Address',

        locationCount:'Location Count',
        ID:'ID',
    },
    dealer:{
        companyName:'Company Name',
        contactPerson:'Contact Person',
        street:'Street',
        houseNumber:'House Number',
        zip:'Zip Code',
        location:'Location',
        country:'Country',
        city:'City',
        phone:'Phone',
        mobile:'Mobile',
        email:'Email',
        website:'Website',
        storeAddress:'Store Address',
        deliveryAddress:'Delivery Address',
        salesAreaApprox:'Sales Area Approx.',
        branches:'Branches',
        branchesReamrk:'Branches Remarks',
        serviceWorkshop:'Service Workshop',
        foundation:'Year of foundation',
        portfolio:'Investing In The TOP 5 Brands',
        copySuccessFul:'Copy Successfully!',
        copyTip:'The validity period of the link is 7 days. Please remind the dealer to fill in the information in a timely manner!',
        erpCode:'ERP Code',
        selectSource:'Please select a channel source',
        qrcode:'QR code',
        syncErpCode:'Sync ERP Code',
        reEnter:'Re-enter',
        contractSigned:'Contract Signed',

        storeHouseNumber:'House Number',
        storeZip:'Zip',
        storeCity:'City',
        storePhone:'Phone',
        storeEmail:'Email',
        deliveryHouseNumber:'House Number',
        deliveryZip:'Zip',
        deliveryCity:'City',
        deliveryPhone:'Phone',
        deliveryEmail:'Email',

        copyLinkTipTitle:"Please remind dealers",
        btnTip:'1. The validity period of the link is 7 days. Please open the link and fill in the information within the validity period.',
        btnTip2:'2. After the form is successfully submitted, the link will also immediately become invalid.',
        qrcodeTip:'Share screenshots with dealers, scan the code to fill out the form',
        qrcodeTip2:'The validity period of the QR code is 7 days',

        setLevel:'Set Level',
        setDealerLevel:'Set Dealer Level',
        erpCode:'Customer ID/Dealer ID',
        erpAutoCode:'Dealer Auto ID',
        dealerLevel:'Dealer Level',
        level:'Level',
        bronze:'Bronze',
        silver:'Silver',
        gold:'Gold',
        platinum:'Platinum',
        
        storeInfo:'Store Information',
        deliveryInfo:'Delivery Information',
        otherInfo:'Other Information',

        exportDealer:'Export Dealer Data',
        paymentType:'Payment Type',

        saleManager:'Area Sale Manager:',
        isActive:'Active:',
        isActive2:'Active',
        testCenter:'Test Center:',
        serviceCenter:'Service Center:',
        saleManager2:'Area Sale Manager',
        isActive2:'Active',
        testCenter2:'Test Center',
        serviceCenter2:'Service Center',
        inactive:'Inactive',
        active:'Active',
        editOtherDealerTip:'Please set at least one item of data!',

        commitment:'Commitment:',
        customerClassification:'Customer Classification:',
        financialInformation:'Financial Information:',
        year:'Year est. :',
        estimate:'Quantity est. :',
        commitment2:'Commitment',
        customerClassification2:'Customer Classification',
        financialInformation2:'Financial Information',
        year2:'Year est.',
        estimate2:'Quantity est.',
        low:'Low',
        middle:'Mid',
        high:'High',
        dzbNumber:'DZB Number',
        bico:'Bank Factoring:',
        bico2:'Bank Factoring',

        shopName:'Shop Name',
        potential:'Potential:',
        potential2:'Potential',
        becomeDealer:'Become Dealer',

        selectLevelTip:'Please select a level !',
        salesNote:'Remark',
        paymentDay:'Payment Day',
        c2cFlag:'Click & Collect',
    },
    kpiDailyReport:{
        item:'ITEM',
        orders:'ORDERS',
        delievered:'DELIEVERED(Confirmed By Customer)',
        cancelled:'CANCELLED',
        shipOut:'SHIP OUT',
        mtd:'MTD',
        ytd:'YTD',
        dailyShipmentData:'Daily Shipment Data',
        NOVEMBER:'NOVEMBER',
        orderDetailExport:'Order Sales Export',
        erpShipExport:'ERP Shippment Export',
        mesShipExport:'MES Shippment Export',
        dateTip:'The data on this page is in the German time zone',

    },
    saleGoal:{
        country:'Country',
        countryCode:'Country Code',
        year:'Year',
        goal:'Goal',
        createGoal:'Create Goal',
        goalSaleNumber:'Goal Sale Number',

        orderChannelType:'Order Channel Type',
        goalType:'Goal Type',
        productType:'Product Type',
        productModelYear:'Product Model Year',
        month:'Month',
        year:'Year',
        yearSummary:'Grand Total',
        monthGoalNumber:'Month Goal Sale Number',
        b2c:'B2C',
        b2b:'B2B',
        c2c:'C&C',
        sales:'SALES',
        bike:'BIKE',
        all:'ALL',
        my23:'MY23',
        my24:'MY24',

        Jan:'Jan',
        Feb:'Feb',
        March:'Mar',
        April:'Apr',
        May:'May',
        June:'Jun',
        July:'Jul',
        Aug:'Aug',
        Sep:'Sep',
        Oct:'Oct',
        Nov:'Nov',
        Dec:'Dec',

        inputGoalSaleNumber:'Please enter goal sale number',
    },
    financial:{
        orderStartDate:'Order Start Date',
        orderEndDate:'Order End Date',
        invoiceStartDate:'Invoice Start Date',
        invoiceEndDate:'Invoice End Date',
        updateStartDate:'Check Start Date',
        updateEndDate:'Check End Date',

        invoiceTimestamp:'Invoice Date',
        financeCheckTime:'Check Date',

        updateOrderStatus:'Update Order Status',
        updatePaymentDate:'Update Pay Date',
        payTimestamp:'Pay Date',

        year:'Year',
        month:'Month',
        recordTimestamp:'Record Date',
        amountIn:'Amount In',
        amountOut:'Amount Out',
        amountTotal:'Amount Total',
        enterCashFlow:'Enter Cash Flow',
        account:'Payable',
        enterAccount:'Enter Payable',

        priceListName:'Price List Name',
        syncERPPrice:'Sync ERP Price List',
        selectChannels:'Select Channels',

        syncTip:'If the channel is not synchronized, it is necessary to synchronize the channel first',

        createLevel:'Create Level', 
        level:'Level',
        exportPriceData:'Export Price Data',
        exportPriceData2:'Order Channels Price Data',

        overdueList:'Overdue List',
        SEPACollection:'SEPA Collection',
        salesName:'Sales Name',
        customer:'Customer',
        overdueDays:'Overdue Days',
        level:'Level',
        invoiceNumber:'Invoice NO.',
        updateTimestamp:'Update Date',
        realPayAmount:'Real Payment',
        confirmExecutionStatusTip:'Confirm Execution Status',
        executionStatus:'Execution Status',
        executed:'Executed',
        unexecute:'Unexecute',
        confirmDate:'Financial Execution Date',
        financeConfirmTime:'Execution Date',
        signDate:'Sign For Date',
        logisticType:'Logistic Type',
        shipSignTemplates:'Sign For Delivery Templates',
        returnSignTemplates:'Sign For Retrun Templates',
        downloadSignTemplate:'Download Template',
        importData:'Import File',
        selectFile:'Select File',

        signType:'Sign Type',
        shipSign:'Sign For Delivery',
        returnSign:'Sign For Return',
    },
    log:{
        orderNo:'Order Number',
        orderName:'Order No.',
        sku:'SKU',
        // source:'Source',
        source:'Channels',
        inventoryCode:'ERP Code',
        message:'Message',
        status:'Status',
        createDate:'Create Date',
        updateDate:'Update Date',
        syncType:'Sync Type',
        syncTimestamp:'Sync Date',

        success:'Success',
        error:'Error',

        model:'Model',
        type:'Type',
        handleData:'Risk Validate',
        createTimestamp:'Operate Date',
        updateUser:'Operator',

        isValid:'Confirmed',
        isRelieve:'Relieved',
        noValid:'Unconfirmed',
    },
    config:{
        vatNo:'VAT NO.',
        enable:'Is It Enable',
        enable2:'Enable',
        disable:'Disable',
        customerType:'Customer Type',
        dealerOverdueEmail:'Email',
        recipientEmail:'Recipient Email',
        CCRecipientEmail:'CC Recipient Email',
        dealerOverdueEmailConfig:'Dealer Overdue',
        recipientEmailConfig:'KPI Daily Recipient',
        CCRecipientEmailConfig:'KPI Daily CC',
        inventoryRecipientEmailConfig:'Inventory Recipient',
        saleEmailConfig:'Credit Limit Approval Failed Recipient',
        inventoryWeekTo:'Inventory Daily Report Recipient',
        inventoryWeekCC:'Inventory Daily Report CC',
        saleName:'Sale Name',
        customerCode:'Channels Number',
        create:'Create',
        creditLevel:'Credit Level',
        status:'Status',
        cooperate:'Cooperate',
        invalid:'Invalid',
        reason:'Reason',
        dateRange:'Date Range',
        ccEmail:'CC Email',
        internalEmail:'Internal Email',
        externalEmail:'External Email',
        inventoryWeeklyReport:'Inventory Weekly Report',
        inventoryWeeklyReportBCC:'Inventory Weekly Report BCC',
        payDiscount:'Payment discount',
        cashDiscount:'Cash discount',
        freight:'Shipping Cost',
        type:'Type',
        discountFreight:'Discount/Freight',
        eu_flag:'EU Member',
        lang:'Language',
        updateTip:'Please enter discount or shipping cost !',
        setDiscountRate:'Set Discount Rate',
        discountRate:'Discount Rate',
    },
    dataBoard:{
        dataStatistics:'Data Statistics',
        vehicleSales:'E-Bike Sales',
        factoryShipmentVolume:'Shipment',
        orderQuantity:'Order Quantity',
        bikeQuantity:'E-Bike Quantity',
        returnQuantity:'Return E-Bike',
        cancelQuantity:'Cancel E-Bike',
        shipmentQuantity:'Shipment E-Bike',
        timelyDeliveryRate:'Timely Delivery Rate',
        outboundBike:'Outbound E-Bike',
        paidButUnshippedBike:'Paid & Unshipped E-Bike',
        unpaidBike:'Unpaid E-Bike',
        fullRefundBike:'Full Refund E-Bike',
        pendingPayBike:'Unpaid & Unshipped E-Bike',
        overdueAndUnpaidBike:'Overdue & Unpaid & Unshipped E-Bike',
        paymentStatistics:'Payment Statistics',
        confirm:'Confirm',
        planShipDate:'Plan Ship Date',
        realShipDate:'Real Ship Date',
        overdueDay:'overdue 15 days',
        category:'Product Category',
        within3:'Within 3 days',
        within7:'Within 7 days',
        over7:'Over 7 days',
        totalEBike:'Total E-Bike',
        past7days:'Default display of data from the past 7 days',
        deliveryRateDetails:'Timely delivery rate details',
        unscheduledOrder:'Unscheduled order'
    },
    setting:{
        menu:'Menu',
        role:'Role',
        user:'User',
        btnAuth:'Authority',
        addButton:'Add Button',
        saveSetting:'Save Setting',
        assignRole:'Assign Role',
        menuName:'Menu Name',
        addMenu:'Add Menu',
        saveMenuSetting:'Save',

        menuType:'Menu Type',
        btnName:'Button Name',
        menuParent:'Menu Parent',
        menuIndex:'Menu Index',
        menuCategory:'Menu Category',
        component:'Component',
        saveSettingMsg:'Are you sure to save',
        assignRoleMsg:'Please select a role',
        assignUserMsg:'Please select a user',

        email:'Email',
        emailMsg:'Email cannot be empty!',
        emailFormat:'Incorrect email format!',

        countryCode:'Country Code',
        countryLocal:'Country Local',
        inputMsg:'Please enter information',

        loginMsg:'Successfully saved, please log out and log in again',
        loginMsg2:'Successfully assign, please log out and log in again',
        loginMsg3:'Successfully delete, please log out and log in again',

        menuName:'Menu Name',
        menuUrl:'Menu Router',
        menuParent:'Parent Menu',
        parentMenuIndex:'Parent Menu Index',
        menuIndex:'Menu Index',
        menuAuth:'Auth',
        rootMenu:'Root Menu',
        edit:'Edit',
        delete:'Delete',
        countryCodeEditMsg:"The three fields of country local, frame number, and logistics are used for invoicing localization settings.",

        order:{
            createOrder:'create order',
            shippingApply:'shipping apply',
            shoppingRecord:'shipping record',
            viewsLogistics:'views logistics',
            refundRecord:'refund record',
            downloadInvoice:'download invoice',
            addOrderLines:'add order lines',
            syncToERP:'sync to erp',
            deleteOrder:'delete order',
            paid:'paid',
            sendInvoice:'send invoice',
            viewVersion:'view version',
            editLine:'edit line',
            deleteLine:'delete line',
            obligation:'pending payment',
            cancelOrder:'cancel order',
            refundOrder:'refund order',
            cancelLineSO:'cancel line so',
            editOrder:'edit order',
            partialPay:'partial paid',
            returnFactory:'return factory',
            deleteInvoice:'delete invoice',
            preInvoiceNo:'pre invoice no.',

            cancelSO:'cancel so',
            cancelSORecord:'cancel so record',
            returnFactoryRecord:'return factory record',
            reissueRecord:'reissue record',
            returnExchange:'return exchange',
            returnExchangeRecord:'return/exchange record',
            riskValidate:'risk validate',

            exportEBike:'export eBike',
            exportOrder:'export order',
            exportCustomer:'export order customer info',

            sendConfirmation:'send confirmation',
            downloadConfirmation:'download confirmation',
            syncNewPrice:'sync unit price',

            editPayTypeDiscount:'edit pay type discount',
            createPrepaymentOrder:'create prepayment order',

            recalculateAmount:'recalculate amount',
            copy:'copy',
            removeLine:'remove order line',

            createServiceOrder:'create service order',
        },
        prepaidOrder:{
            invalidate:'invalidate',
            deliver:'shipping apply',
            downloadInvoice:'download invoice',
            unbind:'Unbind',
        },
        B2BShopOrder:{
            confirm:'confirm',
        },
        dealerOpenOrder:{
            exportExcel:'export excel',
            deliver:'deliver',
        },
        preSaleOrder:{
            importConfig:'import config',
            saveOrder:'save order',
        },
        product:{
            syncERPToOrder:'sync erp product info',
            exportProduct:'export excel',
            exportProductQuery:'export e-bike inventory',
            editPlan:'edit plan',
            exportPlanFile:"export plan file",
            exportReportFile:'export report file',
            splitOrder:'split order',
            maisachEdit:'maisach edit',
            placeOrder:'place order',
            confirmPlaceOrder:'confirm place order',
        },
        customer:{
            syncERPCustomer:'sync erp customer',
            editCustomer:'edit customer',
            addCustomer:'add customer',
            deleteCustomer:'delete customer',
            addCustomerAddress:'add customer address',
            editCustomerAddress:'edit customer address',
            deleteCustomerAddress:'delete customer address',
            addLocation:'add/edit B2B location',
            editLocation:'edit location',
            editPickUpLocation:'edit pickup location',
            saveLocation:'save location',
            savePickUpLocation:'save pickup location',
            editErpCode:'assigned sub erp code',
            deleteSubERPCode:'delete sub erp code',
        },
        invoice:{
            create2CInvoice:'create 2C invoice',
            create2BInvoice:'create 2B invoice',
            downloadInvoice:'re-download invoice',
            reGenerateInvoice:'re-generate invoice',
            sendInvoice:'send invoice',
            deleteInvoice:'delete invoice',
            exportInvoice:'export invoice',
        },
        dashboard:{
            exportFile:'order detail export',
            erpShipExport:'erp shippment export',
            mesShipExport:'mes shippment export',
        },
        error:{

        },
        channelMap:{
            syncERPChannels:'sync channels'
        },
        config:{
            add:'add',
            edit:'edit',
            delete:'delete',
            deleteEmail:'delete email',
            syncERPChannels:'sync channels',
            addRecipientEmail:'add recipient email',
            addCCRecipientEmail:'add cc recipient email',
            addInventoryRecipientEmail:'add inventory recipient email',
            addSaleEmail:'add sale email',
            addInventoryWeekEmail:'add inventory week email',
            deleteRecipientEmail:'delete recipient email',
            deleteCCRecipientEmail:'delete cc recipient email',
            deleteInventoryRecipientEmail:'delete inventory recipient email',
            addInventoryWeeklyReportEmail:'add inventory weekly report email',
            deleteInventoryWeeklyReportEmail:'delete inventory weekly report email',
            addInventoryWeeklyReportCCEmail:'add inventory weekly report cc email',
            deleteInventoryWeeklyReportCCEmail:'delete inventory weekly report cc email',
            deleteSaleEmail:'delete sale email',
            createSaleDealer:'create sale-dealer',
            deleteSaleDealer:'delete sale-dealer',
            deleteInventoryWeekEmail:'delete inventory week email',
            addAreaSaleManager:'add area sale manager',
            deleteAreaSaleManager:'delete area sale manager',
            createShipDateRange:'create ship date range',
            editShipDateRange:'edit ship date range',
            deleteShipDateRange:'delete ship date range',
            setDiscountRate:'set discount rate',
            updateFreight:'update freight',
        },
        sysSetting:{
            addButton:'add button',
            saveSetting:'save setting',
            assignRole:'assign role',
            addEmail:'add email',
            deleteEmail:'delete email',
            addMenu:'add menu'
        },
        stock:{
            signFor:'delivered',
            edit:'edit',
            detail:'detail',
            download:'download outbound delivery note',
            send:'send outbound delivery note',
            cancel:'cancel outbound',
            cancelReturn:'cancel return',
            cancelSwap:'cancel exchange',
            cancelReissue:'cancel re-issue',
            downloadReissue:'download reissue delivery note',
            sendReissue:'send reissue delivery note',
            exportShipment:'export outbonud order',
            zuExportShipment:"zu export outbonud order",
            sendEmailToZU:'send shipment email to zu',
            exportReturn:'export return order',
            exportExchange:'export exchange order',
            exportReissue:'export reissue order',
            exportReturnFactory:'export return factory order',
        },
        approval:{
            closeApproval:'close approval',
            approve:'approve',
            detail:'approve detail',
        },
        dealer:{
            shareLink:'share link',
            syncErpCode:'sync erp code',
            edit:'edit',
            preview:'preview',
            setLevel:'set level',
            detail:'detail',
            reEnter:'re-enter',
            verifyConfirm:'verify and confirm',
            exportDealer:'export dealer',
            becomeDealer:'become dealer',
        },
        saleGoal:{
            createDealerGoal:'create dealer goal',
            editDealerGoal:'edit dealer goal',
            createSaleGoal:'create sale goal',
            editSaleGoal:'edit sale goal',
        },
        financial:{
            updateOrderStatus:'update order status',
            updatePaymentDate:'update payment date',
            enterCashFlow:'enter cash flow',
            editCashFlow:'edit cash flow',
            enterPayable:'enter payable',
            editPayable:'edit payable',
            syncERPPrice:'sync erp price',
            createTax:'create tax rate',
            editTax:'edit tax rate',
            exportPriceData:'export price data',
            editExecuted:'edit',
            downloadSignTemplate:'download sign template',
            importData:'import file',
        },
        inventoryLock:{
            inventoryLockDetail:'inventory lock detail',
            lockInventory:'lock inventory',
            releaseInventory:'release inventory',
            viewLockList:'view order line lock info',
            editLock:'edit lock',
            viewLock:'view lock',
            addLockLine:'add lock line',
            editLockLine:'edit lock line',
            unlockInventory:'unlock inventory',
            deleteLockLine:'delete lock line',
            exportExcel:'export excel',
        },
        returnOrder:{
            createReturnOrder:'create return order',
        },
        plan:{
            addPlan:'add plan',
            importFile:'import file',
            exportFile:'export file',   
            downloadTemplate:'download template',
            editPlan:'edit plan',
            deletePlan:'delete plan',
        },
        warning:{
            changeToError:'change to error'
        },
    },
    dealerForm:{
        title:'BECOME A HEPHA DEALER',
        subTitle:'We are very pleased to welcome you as a HEPHA dealer! May we ask you to give us some info so that we can create you as a customer.',
        confirmTip:'I hereby confirm the data protection provisions of Hepha GmbH and expressly permit HEPHA GmbH to contact me via eMail or by telephone.',
        signDate:'Place,date',
        signName:'Signature', 

        companyName:'Company name',
        contactPerson:'Contact person',
        street:'Street',
        houseNumber:'House number',
        zipCode:'Zip Code',
        location:'Location',
        country:'Country',
        city:'City',
        phone:'Phone',
        mobile:'Mobile',
        email:'Email',
        website:'Website',
        vatNo:'Vat No.',

        storeAddress:'Store address',
        deliveryAddress:'Delivery address',
        salesAreaApprox:'Sales area approx.',
        branches:'Branches',
        serviceWorkshop:'Service workshop',
        yearOfFoundation:'Year of foundation',
        portfolio:'Top 5 brands in your portfolio',
        branchesRemark:'Yes and these are:',
        No:'No',
        Yes:'Yes',
        ok:'OK',
        cancel:'Cancel',
        tip:'Tip',

        submitting:'Submitting, please do not close the page',
        submit:'Submit',
        language:'Language',
        close:'Close',
        empty:'Empty',
        generateImages:'Generate images',
        notEmpty:'cannot be empty',
        signConfirm:'Please sign to confirm',
        pleaseSelect:'Please select ...',
        submitTip:'After submission, it cannot be modified. ',
        submitTip2:'Please confirm if the information filled in is accurate',
        emailError:'Email format error',
        linkExpired:'Link has expired!',
        submitSuccessful:'Submitted Successfully!',
    }
}